import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { ReactElement } from 'react';
import {
    labelWrapper,
    styledAnswerContainerStyle
} from '../question.styles.css';

type SavedQuestionProps = {
    id: string;
    text: string;
    questionLabel: string;
    testId?: string;
    editButton?: ReactElement;
};

export const SavedQuestion = ({
    id,
    text,
    questionLabel,
    testId,
    editButton
}: SavedQuestionProps) => (
    <div data-testid={testId} className={styledAnswerContainerStyle}>
        <p>
            <span id={id} className={`${labelWrapper} ${fontGroups.fork}`}>
                {questionLabel}
            </span>
            <strong className={fontGroups.ladle}>{text}</strong>
        </p>
        {editButton}
    </div>
);
